export const fontVariation = (type, elements) => {
  const divisableNumber = 10;
  const incrementer = 0.2; // increase font size by 0.2rem i.e 2px

  const processFontStyle = (type, element) => {
    return (element.style.fontSize =
      type === "zoom-in"
        ? parseFloat(getComputedStyle(element).fontSize) / divisableNumber + incrementer + "rem"
        : parseFloat(getComputedStyle(element).fontSize) / divisableNumber - incrementer + "rem");
  };

  const computeStyles = (elements) => {
    Array.from(elements).forEach((element) => processFontStyle(type, element));
  };
  computeStyles(elements);
};

export const printStory = () => {
  window.print();
};

export const copyToClipboard = (storyUrl, setShowCopy) => {
  const textArea = document.createElement("textarea");
  document.body.appendChild(textArea);
  textArea.value = storyUrl;
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);

  setShowCopy(true);
};
